import React, { useState } from "react";
import "../styles/mobilequestionanalysis.css";
import QuestionPreviewSheet from "./QuestionPreviewSheet";




const MobileQuestionAnalysis = ({
    subcats,
    quesData,
    ansArray,
    
}) => {

 const [selectedQuestion, setSelectedQuestion] = useState(null);

    return (

        <section className="mqa-section">

            <h2 className="mqa-heading">

                Question Wise Analysis

            </h2>

            {

                subcats.map((chapter,index)=>(

                    <ChapterCard

                        key={index}

                        chapter={chapter}

                        quesData={quesData}

                        ansArray={ansArray}

                        onChipClick={setSelectedQuestion}

                    />

                ))

            }

           <QuestionPreviewSheet
    question={
        selectedQuestion !== null
            ? quesData[selectedQuestion]
            : null
    }
    questionNumber={
        selectedQuestion !== null
            ? selectedQuestion + 1
            : 0
    }
    totalQuestions={quesData.length}
    userAnswer={
        selectedQuestion !== null
            ? ansArray[selectedQuestion]
            : null
    }
    onClose={() => setSelectedQuestion(null)}
    onPrevious={() =>
        setSelectedQuestion(prev => Math.max(prev - 1, 0))
    }
    onNext={() =>
        setSelectedQuestion(prev => Math.min(prev + 1, quesData.length - 1))
    }
/>

        </section>



    );






};

const ChipGroup = ({
    title,
    emoji,
    chips,
    type,
    onChipClick
}) => {

    if(chips.length===0) return null;

    return(

        <div className="mqa-group">

            <div className="mqa-label">

                {emoji} {title}

            </div>

            <div className="mqa-chip-container">

                {

                  chips.map((num) => (
    <button
        key={num}
        type="button"
        className={`mqa-chip ${type}`}
        onClick={() => onChipClick(num - 1)}
    >
        {num}
    </button>
))

                }

            </div>

        </div>

    );

};

 const ChapterCard = ({
    chapter,
    quesData,
    ansArray,
    onChipClick
}) => {

    const chapterName = chapter[0];

    const correct = [];
    const wrong = [];
    const skipped = [];

    quesData.forEach((q, index) => {

        if (q.SubCatName !== chapterName) return;

        const userAnswer = ansArray[index];

        if (userAnswer === undefined) {

            skipped.push(index + 1);

        } else if (userAnswer === q.Answer) {

          correct.push(index + 1);

        } else {

            wrong.push(index + 1);

        }

    });

    return (

        <div className="mqa-card">

            <h3 className="mqa-title">

                {chapterName}

            </h3>

            <ChipGroup
                title="Correct"
                emoji="🟢"
                chips={correct}
                type="correct"
                onChipClick={onChipClick}
            />

            <ChipGroup
                title="Wrong"
                emoji="🔴"
                chips={wrong}
                type="wrong"
                onChipClick={onChipClick}
            />

            <ChipGroup
                title="Not Attempted"
                emoji="⚪"
                chips={skipped}
                type="skip"
                onChipClick={onChipClick}
            />

        </div>

    );

};

export default MobileQuestionAnalysis;